/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export function giftCard () {
  return {
    namespaced: true,
    state: {
      customerGiftCards: [],
      currentGiftCard: null
    },
    getters,
    actions,
    mutations
  }
}
